/** Fixed screen-space dimensions shared by the paper and aerial trace maps. */
export const LEG_PILL_HEIGHT = 29
const LEG_PILL_DISTANCE_WIDTH = 39
const LEG_PILL_STANDARD_CLUB_WIDTH = 26
const LEG_PILL_MAX_CLUB_WIDTH = 52
const LEG_PILL_MAX_WIDTH = LEG_PILL_MAX_CLUB_WIDTH + LEG_PILL_DISTANCE_WIDTH

interface LegPillLayout {
  clubWidth: number
  distanceWidth: number
  width: number
  displayClub: string | null
  /** Compress only names that outgrow the standard chip; short codes stay natural. */
  clubTextLength: number | null
}

/**
 * Caddie accepts older free-text club names as well as today's short picker
 * codes. Widen the chip first, then cap and fit the text so neither can trespass
 * into the distance half. The full saved value remains in the map description.
 */
export function legPillLayout(club: string | null): LegPillLayout {
  if (club === null) {
    return {
      clubWidth: 0,
      distanceWidth: LEG_PILL_DISTANCE_WIDTH,
      width: LEG_PILL_DISTANCE_WIDTH,
      displayClub: null,
      clubTextLength: null,
    }
  }

  const characters = Array.from(club)
  const displayClub = characters.length > 8 ? `${characters.slice(0, 7).join('')}…` : club
  const glyphs = Array.from(displayClub).length
  const clubWidth = Math.min(
    LEG_PILL_MAX_CLUB_WIDTH,
    Math.max(LEG_PILL_STANDARD_CLUB_WIDTH, 12 + glyphs * 6),
  )

  return {
    clubWidth,
    distanceWidth: LEG_PILL_DISTANCE_WIDTH,
    width: clubWidth + LEG_PILL_DISTANCE_WIDTH,
    displayClub,
    clubTextLength: glyphs > 3 ? clubWidth - 10 : null,
  }
}

/** Counter-scale SVG furniture so its approved dimensions are CSS pixels. */
export function holePlanFurnitureScale(viewBoxWidth: number, renderedWidth: number): number {
  return Number.isFinite(renderedWidth) && renderedWidth > 0 ? viewBoxWidth / renderedWidth : 1
}

/** Put the pill toward the plan centre, away from whichever edge owns the Shot. */
export function pillPlacementFor(
  point: PlanPoint,
  plan: { width: number; height: number },
  pillWidth = LEG_PILL_MAX_WIDTH,
): PlanPoint {
  return {
    x: point.x <= plan.width / 2 ? 16 : -16 - pillWidth,
    y: point.y <= plan.height / 2 ? 15 : -34,
  }
}
import type { PlanPoint } from '../../lib/holeProjection'
